export default {
  methods: {
    /**
     * This will set a classname to have a specific text color based on the field validation status
     * @param {String} event - field event
     * @param {String} fieldClassName - field classname
     */
    fieldEventCommonStyle (event, fieldClassName, backgroundColor) {
      const parentEl = $(`.${fieldClassName}`).parents(':eq(1)')

      // on Focus
      if (event === 'focus') {
        parentEl.removeClass('cstm-txtcolor-red')
        parentEl.removeClass('cstm-txtcolor-white')
        parentEl.removeClass('cstm-txtcolor-grey')

        if (backgroundColor && backgroundColor === 'white') {
          parentEl.addClass('cstm-txtcolor-grey')
        } else {
          parentEl.addClass('cstm-txtcolor-white')
        }

        if (parentEl.hasClass('is-error')) {
          parentEl.find('.el-form-item__error').addClass('not-visible')
        }

        if (parentEl.hasClass('is-error-api')) {
          parentEl.removeClass('is-error-api hide-input-text cstm-txtcolor-white')
          parentEl.find('.backend-error-msg').addClass('hide')
        }
      }

      // On Blur
      if (event === 'blur') {
        if (parentEl.hasClass('is-error')) {
          parentEl.removeClass('cstm-txtcolor-white').addClass('cstm-txtcolor-red')
          parentEl.find('.el-form-item__error').removeClass('not-visible')
        }

        if (parentEl.hasClass('is-error-api')) {
          parentEl.removeClass('cstm-txtcolor-red').addClass('cstm-txtcolor-white')

          if (backgroundColor && backgroundColor === 'white') {
            parentEl.addClass('cstm-txtcolor-grey')
          } else {
            parentEl.addClass('cstm-txtcolor-white')
          }
        }
      }
    },
    handleFieldClick () {
      $(document).on('click', '.el-form-item', (el) => {
        if ($(el.target).hasClass('el-form-item__error')) {
          $(el.target).addClass('not-visible')
        }

        if ($(el.target).hasClass('el-input__inner') && $(el.currentTarget).hasClass('is-error')) {
          $(el.currentTarget).find('.el-form-item__error').addClass('not-visible')
        }

        // For custom error message clicked
        if ($(el.target).hasClass('cstm-form-item_error')) {
          $(el.target).removeClass('show').addClass('hide')
          $(el.target).parent().find('input').focus()
        }
      })
    },
    handleBackendErrorMessageClick () {
      $(document).on('click', '.backend-error-msg', (el) => {
        const elClasses = $(el.currentTarget).attr('class').split(' ')
        let targetFormItemClass = null

        for (const indx in elClasses) {
          if (elClasses[indx].includes('target-el-form-item')) {
            const trgClassSplt = elClasses[indx].split('_')
            targetFormItemClass = trgClassSplt[1]

            break
          }
        }

        $(el.currentTarget).addClass('hide') // hide error msg with red box
        // Show input text and focus
        const targetFormItemEl = $(`.el-form-item.${targetFormItemClass}`)
        targetFormItemEl.removeClass('hide-input-text is-error-api')
        targetFormItemEl.find('input').focus()
      })
    }
  },
  mounted () {
    this.handleFieldClick()
    this.handleBackendErrorMessageClick()
  }
}
